import { IPopularSearchAttributesValue, ResultObjectType } from '@cbgms/api'
import { ResultTitle } from './Title'
import { Box, Typography } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { useCallback } from 'react'

export interface TyreSizeResultProps {
  Type: ResultObjectType
  clearQuery: () => void
  hasGroupHeader: boolean
  primaryAction: () => Promise<void>
  option: IPopularSearchAttributesValue
}

const TyreSizeResult: React.FC<TyreSizeResultProps> = ({ option, hasGroupHeader, primaryAction }) => {
  const onClick = useCallback(
    (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      e.stopPropagation()
      primaryAction()
    },
    [primaryAction]
  )
  return (
    <Box key={option.DisplayName} onClick={onClick} sx={{ display: 'flex' }}>
      <SearchIcon sx={{ opacity: 0.7 }} />
      <Box sx={{ display: 'flex', flexDirection: 'column', pl: 1 }}>
        <ResultTitle resultType={ResultObjectType.TyreSize} isTitleVisible={!hasGroupHeader} />
        <Typography sx={{ '&:not(:last-child)': { pt: 1 } }}>{option.DisplayName}</Typography>
      </Box>
    </Box>
  )
}

export default TyreSizeResult
